/* eslint-disable react/jsx-no-target-blank */
import {useIntl} from 'react-intl'
import {SidebarMenuItem} from './SidebarMenuItem'
import {SidebarSectionLabel} from './SidebarSectionLabel'
import {getRoleIdFromAuth} from '../../../../helpers/crud-helper/consts'

const SidebarMenuMain = () => {
  const intl = useIntl()
  const roleId = getRoleIdFromAuth()

  return (
    <>
      <SidebarMenuItem
        to='/apps/quotation-management/quotations'
        icon='element-11'
        title={intl.formatMessage({id: 'MENU.QUOTATIONS'})}
        fontIcon='bi-app-indicator'
      />
      <SidebarSectionLabel title={intl.formatMessage({id: 'MENU.GENERAL'})} />

      <SidebarMenuItem
        to='/apps/concept-management/concepts'
        title={intl.formatMessage({id: 'MENU.CONCEPTS'})}
        icon='bank'
      />
      {/* <SidebarMenuItem
        to='/apps/matrix-management/matrices'
        title={intl.formatMessage({id: 'MENU.MATRICES'})}
        fontIcon='bi-person'
        icon='discount'
      /> */}
      <SidebarMenuItem
        to='/apps/client-management/clients'
        title={intl.formatMessage({id: 'MENU.CLIENTS'})}
        fontIcon='bi-person'
        icon='people'
      />
      {roleId === 1 && (
        <>
          <SidebarMenuItem
            to='/apps/settings-management'
            title={intl.formatMessage({id: 'MENU.SETTINGS'})}
            fontIcon='bi-person'
            icon='discount'
          />
          <SidebarMenuItem
            to='/apps/logs-management/logs'
            title={intl.formatMessage({id: 'MENU.LOGS'})}
            fontIcon='bi-person'
            icon='information-5'
          />
        </>
      )}
    </>
  )
}

export {SidebarMenuMain}
